import Modal from "./_bootstrapModalExtensions";

export function InitFavoriteSettlementFilter(attributeName: string) {
    $('#favorite-settlements-switch').click((event: JQuery.TriggeredEvent) => FavoriteSettlementFilterSwitchChanged(event, attributeName));
}

export function FavoriteSettlementFilterSwitchChanged(event: JQuery.TriggeredEvent, attributeName: string) {

    let btn = $(event.target);

    let switchValue: boolean = $(event.target).prop('checked') as boolean;
    let gridName = btn.data('grid-name');
    let grid: any = window[gridName];

    window.SettingsManager.setAttribute(attributeName, switchValue);

    grid.Refresh();
}

export function SetFavoriteSettlementFilterVisibility(visible: boolean) {
    let $favoriteFilterSection: JQuery = $('#settlement-filter-wrapper');

    if (visible) {
        $favoriteFilterSection.show();
    } else {
        $favoriteFilterSection.hide();
    }
}

export function LoadFavoriteSettlementFilterValueFromSettings(visible: boolean, attributeName: string) {
    let $filterSwitch: JQuery = $('#favorite-settlements-switch');

    if ($filterSwitch.length === 0) {
        return;
    }

    if (visible) {
        let savedSwitchposition: boolean = window.SettingsManager.getAttribute(attributeName) as boolean;

        $filterSwitch.prop('checked', savedSwitchposition);
    }
    else {
        $filterSwitch.prop('checked', false)
    }
}

export function ShowFavoriteSettlementSettings(event: JQuery.TriggeredEvent) {
    let userId: number = $(event.target).data('userid') as number;

    Modal.FavoriteSettlementSettingsModal(window.ETDR_RD.appConfig['UrlAction.GetUsersFavoriteSettlements'], userId);
}

export function FavoriteSettlementSelectionChanged(s: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    let grid: MVCxClientGridView = s as MVCxClientGridView;

    $("#selected-settlement-count").html(grid.GetSelectedRowCount().toString());

    grid.Refresh();
}

export function DeleteSettlementFromList(e: Event) {
    let grid: MVCxClientGridView = window["SettlementAndTerritoryList"];
    let rowkey = $(e).data("gv-row-key");

    if (rowkey != 'undefined') {
        grid.UnselectRowsByKey(rowkey);
    }
}

export function ToggleAlertVisibilityForProcessAndFilingList(grid: MVCxClientGridView) {
    let searchPanelFilter: string = grid.cpSearchPanelFilter;
    let needToFilterForFavoriteSettlements: boolean = $('#favorite-settlements-switch:checkbox').is(':checked');

    let shouldDisplayWarningAboutActiveFilter = !!searchPanelFilter || needToFilterForFavoriteSettlements;
    if (shouldDisplayWarningAboutActiveFilter) {
        $('#gridview-alert-bar').show();
    } else {
        $('#gridview-alert-bar').hide();
    }
}

export function OnClearFiltersButtonClicked(event: JQuery.TriggeredEvent) {
    let btn = $(event.target);

    let clearSettlementFilter: boolean = btn.data('clear-settlement-filter');
    let $searchStringInputField: JQuery<HTMLElement> = $('.search-panel-search-field');
    let gridName: string = btn.data('grid-name');

    let grid: any = window[gridName];

    if (clearSettlementFilter) {
        let $filterSwitch: JQuery = $('#favorite-settlements-switch');
        $filterSwitch.prop('checked', false);
    }

    if ($searchStringInputField.length > 0) {
        $searchStringInputField.val('');
    }

    grid.ApplySearchPanelFilter('')
}

export function RefreshGrid(event: JQuery.TriggeredEvent) {

    let btn = $(event.currentTarget);
    let gridName = btn.data('grid-name') as string;
    let grid = window[gridName] as MVCxClientGridView;

    grid.Refresh();
}

jQuery(() => {
    $(document).on('keypress', '.click-element-on-enter', (event: JQuery.KeyPressEvent) => {
        // If the user presses Enter while in the quickfilter value field, simulate a click. Basically search on enter.
        if (event.keyCode == 13) {
            let elem = $(event.currentTarget);

            let targetToClickSelector = elem.data('element-to-click');

            let targetToClick = $(targetToClickSelector);
            targetToClick.click();
        }
    });

    $('#gridViewFilter-clearFilters').click((event: JQuery.TriggeredEvent) => OnClearFiltersButtonClicked(event));

    $('#settlement-filter-settings').click((event: JQuery.TriggeredEvent) => ShowFavoriteSettlementSettings(event));

    $('#ics-search-button, #si-scs-search-button').click((event: JQuery.TriggeredEvent) => {
        RefreshGrid(event);
    });
});
